import { InlineText1 } from '@cian/ui-kit/typography';
import * as React from 'react';
import { Collapse } from '../../../common/Collapse';
import { BetInputContainer } from '../BetInput';
import { SERVICE_NAMES } from './constants';
import * as styles from './AuctionDesktop.css';
import { BetPositionContainer } from '../BetPosition';
import { BetLeadersContainer } from '../BetLeaders';
import { BetLeadersTitleContainer } from '../BetLeadersTitle';
import { AutobrokerContainer } from '../Autobroker';

interface IAuctionDesktopProps {
  isOpen: boolean;
  isAutobrokerEnabled: boolean;
  serviceId: string;
  onClick(): void;
}

export const AuctionDesktop = ({ isOpen, isAutobrokerEnabled, serviceId, onClick }: IAuctionDesktopProps) => {
  const title = `Опередить другие ${SERVICE_NAMES[serviceId]}`;

  return (
    <div className={styles['wrapper']}>
      <Collapse isOpen={isOpen} title={title} onClick={onClick}>
        {isAutobrokerEnabled && (
          <div className={styles['autobroker-wrapper']}>
            <AutobrokerContainer />
          </div>
        )}

        {!isAutobrokerEnabled && (
          <div className={styles['auction-wrapper']}>
            <InlineText1>
              Всё работает по&nbsp;принципу аукциона. Вы делаете ставку на&nbsp;позицию, <br /> и&nbsp;эта&nbsp;позиция
              фиксируется до&nbsp;тех&nbsp;пор, пока&nbsp;кто-то не&nbsp;перебьёт вашу ставку.
            </InlineText1>

            <div className={styles['auction-layout']}>
              <div>
                <BetLeadersTitleContainer />
                <BetLeadersContainer />
              </div>

              <div className={styles['bet']}>
                <BetInputContainer />
                <BetPositionContainer />
              </div>
            </div>
          </div>
        )}
      </Collapse>
    </div>
  );
};
